export default "__VITE_ASSET__DFy$Y3Vz__"